import React from "react";
import { Outlet } from "react-router-dom";

export const FormsPage: React.FC = () => {
	return <Outlet />;
};
